export const GET_WEATHER_SUCCESS = 'wholesale/GET_WEATHER_SUCCESS'
export const GET_WEATHER_FAILURE = 'wholesale/GET_WEATHER_FAILURE'
